import { useEffect } from 'react';

const SeoHead = () => {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://www.dronefacilsp.com';

    const existingScripts = document.querySelectorAll('script[data-seo="home"]');
    existingScripts.forEach((s) => s.remove());

    const webPageSchema = {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': `${siteUrl}/#webpage`,
      url: `${siteUrl}/`,
      name: 'Drone Fácil SP | Drone Profissional São Paulo | Obras, Imobiliárias e Eventos',
      description:
        'Drone Fácil SP: serviços profissionais com drone em São Paulo. Acompanhamento de obras, fotos para imobiliárias, cobertura de eventos e mapeamento aéreo. Certificado ANAC.',
      inLanguage: 'pt-BR',
      isPartOf: {
        '@type': 'WebSite',
        '@id': `${siteUrl}/#website`,
        url: `${siteUrl}/`,
        name: 'Drone Fácil SP',
        description: 'Serviços profissionais com drone em São Paulo',
        inLanguage: 'pt-BR',
        publisher: {
          '@type': 'Organization',
          name: 'Drone Fácil SP',
          url: `${siteUrl}/`,
          logo: {
            '@type': 'ImageObject',
            url: 'https://static.readdy.ai/image/42fe69e6e6278085a7d1118870fd6d3f/d255c81127e1c3e18b76562d5f90469f.png',
          },
        },
      },
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'Início',
            item: `${siteUrl}/`,
          },
        ],
      },
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-seo', 'home');
    script.textContent = JSON.stringify(webPageSchema);
    document.head.appendChild(script);

    return () => {
      const scripts = document.querySelectorAll('script[data-seo="home"]');
      scripts.forEach((s) => s.remove());
    };
  }, []);

  return null;
};

export default SeoHead;
